import {createContext} from "react";
import { AppTitle } from "../hooks/useAppTitle";

const AppTitleContext = createContext<AppTitle>({
    title: [],
    updateAppSuffix: (value) => {},
    updateAppTitle: (value) => {},
});

export default AppTitleContext;